/**
 * src/components/ui/Badge.jsx
 * Badge de estado con dot indicator.
 */

const COLORS = {
  green:  { bg: 'rgba(16,185,129,0.12)', color: '#10b981', dot: '#10b981' },
  red:    { bg: 'rgba(239,68,68,0.12)',  color: '#ef4444', dot: '#ef4444' },
  yellow: { bg: 'rgba(245,158,11,0.12)', color: '#f59e0b', dot: '#f59e0b' },
  blue:   { bg: 'rgba(59,130,246,0.12)', color: '#3b82f6', dot: '#3b82f6' },
  gray:   { bg: 'rgba(100,116,139,0.12)',color: '#64748b', dot: '#64748b' },
  purple: { bg: 'rgba(139,92,246,0.12)', color: '#8b5cf6', dot: '#8b5cf6' },
}

// Mapa semántico para resultados de pipeline
export const RESULTADO_COLOR = {
  ok:      'green',
  error:   'red',
  running: 'blue',
  warning: 'yellow',
}

export const TIER_COLOR = {
  premium: 'purple',
  pro:     'blue',
  basic:   'gray',
}

export function Badge({ children, color = 'gray', dot = false, pulse = false }) {
  const c = COLORS[color] || COLORS.gray

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '5px',
      background: c.bg, color: c.color,
      padding: '2px 8px', borderRadius: '999px',
      fontSize: '11px', fontWeight: 500,
      fontFamily: 'var(--font-mono)', letterSpacing: '0.04em',
      whiteSpace: 'nowrap',
    }}>
      {dot && (
        <span style={{
          width: '6px', height: '6px', borderRadius: '50%',
          background: c.dot, flexShrink: 0,
          ...(pulse ? { animation: 'pulseDot 1.4s ease-in-out infinite' } : {}),
        }} />
      )}
      {children}
    </span>
  )
}
